import React from "react";
import contextProvider from "../../contextProvider";
import {
  ResponsiveContainer,
  PieChart as _PieChart,
  Pie,
  Cell,
  Sector,
  Tooltip,
} from "recharts";
// import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";

import Section from "../../_L1_components/Layout/Section";

const context_exposed_methods = ["setActive", "unsetActive", "reset"];

class PieChart extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      activeIndex: null,
    };
    super(props, initState);
  }

  setActive(data, index) {
    this.setState(
      {
        activeIndex: index,
      },
      () => {
        if (this.props.onSetActive) {
          this.props.onSetActive(data, index);
        }
      }
    );
  }

  unsetActive() {
    this.setState(
      {
        activeIndex: this.props.default !== undefined ? this.props.default : null,
      },
      () => {
        if (this.props.onUnsetActive) {
          this.props.onUnsetActive(
            this.props.default !== undefined && this.props.data
              ? this.props.data[this.props.default]
              : false,
            this.props.default !== undefined ? this.props.default : false
          );
        }
      }
    );
  }

  renderActiveShape(props) {
    //	const RADIAN = Math.PI / 180;
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, name } = props;
    //	const sin = Math.sin(-RADIAN * midAngle);
    //	const cos = Math.cos(-RADIAN * midAngle);
    //	const sx = cx + (outerRadius + 10) * cos;
    //	const sy = cy + (outerRadius + 10) * sin;
    //	const mx = cx + (outerRadius + 30) * cos;
    //	const my = cy + (outerRadius + 30) * sin;
    //	const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    //	const ey = my;
    //	const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g
        style={this.props.style}
        // id={this.props.tooltip ? this.props.tooltip.target : null}
      >
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={
            outerRadius +
            4 +
            (this.props.perimeterStroke && props.perimeterStroke
              ? this.props.perimeterStroke.width
              : 0)
          }
          outerRadius={
            outerRadius +
            10 +
            (this.props.perimeterStroke && props.perimeterStroke
              ? this.props.perimeterStroke.width
              : 0)
          }
          fill={name == "DISCEARLY" ? "#0774f2" : fill} // change this for earlydrop
        />
      </g>
    );
  }

  reset() {
    this._defaultSet = false;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    if (this.props.onControllerReady) {
      this.props.onControllerReady(this.getContext().PieChart);
    }
  }

  onComponentWillUnmount() {}

  onRender() {
    if (this.props.data && this.props.default !== undefined && !this._defaultSet) {
      this.setActive(this.props.data[this.props.default], this.props.default);
      this._defaultSet = true;
    }
    return (
      <Section className="pie-chart" designType="wide">
        <svg
          width="0"
          height="0"
          id="10015.io"
          viewBox="0 0 1200 630"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="pattern"
              x="0"
              y="0"
              width="5"
              height="5"
              patternUnits="userSpaceOnUse"
              patternTransform="translate(0, 0) rotate(45) skewX(0)"
            >
              <svg width="8" height="8" viewBox="0 0 100 100">
                <rect x="0" y="0" width="100%" height="100%" fill="#a5dcff"></rect>
                <g fill="#0774f2" opacity="1">
                  <path d="M60 0H40V40H0V60H40V100H60V60H100V40H60V0Z"></path>
                </g>
              </svg>
            </pattern>
          </defs>
        </svg>

        <ResponsiveContainer aspect={1}>
          <_PieChart
            onMouseLeave={() => {
              this.unsetActive();
              //	this.setState({
              //		activeIndex: false,
              //	});
              //	if (this.props.onItemMouseLeave) {
              //		this.props.onItemMouseLeave();
              //	}
            }}
          >
            <Pie
              data={this.props.data || []}
              nameKey={this.props.nameKey}
              dataKey={this.props.dataKey}
              onClick={(data) => {
                this.props.onClick && this.props.onClick(data);
              }}
              activeIndex={this.state.activeIndex}
              activeShape={this.renderActiveShape.bind(this)}
              startAngle={90}
              endAngle={-270}
              animationEasing="ease-in-out"
              animationBegin={100}
              animationDuration={400}
              innerRadius={this.props.innerRadius ? this.props.innerRadius + "%" : "40%"}
              outerRadius={
                this.props.perimeterStroke
                  ? 85 - this.props.perimeterStroke.width + "%"
                  : null
              }
              onMouseOver={(data, index) => {
                this.setActive(data, index);
              }}
            >
              {(this.props.data || []).map((entry, key) => {
                let color = entry.color;
                if (entry.phase == "DISCEARLY") {
                  color = "url(#pattern)";
                }
                return <Cell key={key} fill={color} style={{ zIndex: "0" }} />;
              })}
            </Pie>
            {this.props.tooltip ? (
              <Tooltip
                isAnimationActive={false}
                // // animationBegin={500}
                // // animationDuration={500}
                content={(props) => {
                  const { active } = props;
                  if (active) {
                    return (
                      <div className="p-1 custom-tooltip-pie rounded">
                        {this.props.tooltip.text}
                      </div>
                    );
                  } else {
                    return null;
                  }
                }}
              />
            ) : null}
            {this.props.perimeterStroke &&
            typeof this.props.perimeterStroke == "object" ? (
              <Pie
                data={this.props.data || []}
                nameKey={this.props.nameKey}
                dataKey={this.props.dataKey}
                startAngle={90}
                endAngle={-270}
                innerRadius={80 - this.props.perimeterStroke.width + "%"} // 80 perchè il massimo sembra essere 80% e non 100%...
                fill={this.props.perimeterStroke.color}
              >
                {(this.props.data || []).map((entry, key) => {
                  // console.log("entry", entry.phase);
                  return (
                    <Cell
                      key={key}
                      fill={
                        entry.perimeterStroke
                          ? this.props.perimeterStroke.colorsObj[entry.phase]
                          : "transparent"
                      }
                      style={{
                        zIndex: "0",
                      }}
                    />
                  );
                })}
              </Pie>
            ) : null}
          </_PieChart>
        </ResponsiveContainer>
      </Section>
    );
  }
}

export default contextProvider(
  withDefinedContext(PieChart, "PieChart", context_exposed_methods),
  {
    define: null,
  }
);
